module.exports = __webpack_public_path__ + "img/s2v3.554e622a.jpeg";